import React from 'react';

const Forbidden = () => (<h2>Ooops! You are forbidden</h2>);

export default Forbidden;
